<template>
  <div>
    <div class="tabel-bar">
      <div class="tabel-bar-left">
        <el-button type="primary" size="medium" @click="rolePopup()"
          >新增角色</el-button
        >
        <RemoveButton
          type="info"
          size="medium"
          @click="handleRemoveAll"
          :disabled="!selectionID.length"
        >批量删除</RemoveButton>
      </div>
      <div class="tabel-bar-right">
        <el-input
          placeholder="请输入内容"
          size="medium"
          prefix-icon="el-icon-search"
          v-model="keywords"
          @input="search"
        ></el-input>
        <el-tooltip effect="dark" content="刷新列表" placement="bottom">
          <span
            class="el-icon-refresh icon-hover refresh-btn"
            @click="debounceRefresh"
          ></span>
        </el-tooltip>
      </div>
    </div>
    <el-table v-loading="loading" :data="tableData" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="id" label="ID" width="80"> </el-table-column>
      <el-table-column prop="name" label="角色名称">
        <template slot-scope="scope">
          <span @click="roleDetailShow(scope.row.id)">{{
            scope.row.name
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="rolePopup(scope.row.id)"
            >编辑</el-button
          >
          <el-button type="text" @click="roleDel(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-size="size"
      :total="total"
    >
    </pagination>
    <!-- 角色表单 -->
    <el-dialog  :close-on-click-modal="false" :append-to-body="true" :title="title" :visible.sync="roleFormVisible" center>
      <el-form
        :model="roleForm"
        size="medium"
        :rules="roleFormRules"
        ref="refroleForm"
        label-width="100px"
      >
        <el-form-item label="角色名称：" prop="name">
          <el-input
            v-model="roleForm.name"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" :disabled="isDisabled" @click="debounceSubmit">确 定</el-button>
        <el-button size="medium" @click="roleFormVisible = false"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import { debounce } from 'throttle-debounce'
import {
  getRoleList,
  putRoleAdd,
  getRoleDetail,
  postRoleEdit,
  deleteRoleDel,
  delRoleList
} from '@/api/role'

const createFormVals = () => ({
  name: ''
})

export default {
  data() {
    return {
      currentID: null,
      isDisabled: false,
      roleFormVisible: false,
      total: 0,
      size: 10,
      page: 1,
      keywords: '',
      tableData: [],
      detailDate: [],
      roleForm: createFormVals(),
      loading: true,
      selectionID: [],
      roleFormRules: {}
    }
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  computed: {
    title() {
      return this.currentID ? '编辑角色' : '新增角色'
    }
  },
  created() {
    this.debounceSubmit = debounce(300, this.roleSubmit)
    this.debounceRefresh = debounce(300, this.refresh)
  },
  methods: {
    handleSelectionChange(selection) {
      this.selectionID = selection.map(_ => _.id)
    },
    handleRemoveAll() {
      delRoleList(this.selectionID).then(res => {
        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getRoleListData()
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    // 分页
    handleSizeChange(val) {
      this.size = val
      this.getRoleListData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getRoleListData()
    },
    // 删除角色
    roleDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteRoleDel({
            id: id
          }).then(res => {
            if (res.status === 1) {
              this.$message.success('删除角色成功')
              this.getRoleListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 新增/编辑角色
    roleSubmit() {
      this.$refs.refroleForm.validate(valid => {
        if (!valid) return false
        const changeRole = this.currentID ? postRoleEdit : putRoleAdd
        changeRole({
          name: this.roleForm.name,
          id: this.currentID || undefined
        }).then(res => {
          if (res.status === 1) {
            this.currentID ? this.$message.success('编辑角色成功') : this.$message.success('新增角色成功')
            this.roleFormVisible = false
            this.getRoleListData()
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
      })
    },
    // 打开角色表单
    rolePopup(id) {
      const isAdd = !id
      this.roleFormVisible = true

      if (isAdd) {
        this.$set(this, 'roleForm', createFormVals())
        this.currentID = null
      } else {
        this.isDisabled = true
        this.currentID = id
        getRoleDetail({ id }).then(res => {
          if (res.status === 1) {
            this.roleForm.name = res.data.name
            this.isDisabled = false
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 检索
    search() {
      this.getRoleListData()
    },
    // 刷新数据表格
    refresh() {
      this.getRoleListData()
      this.$message.success('数据刷新成功')
    },
    // 获取角色列表
    getRoleListData() {
      this.loading = true
      getRoleList({
        page: this.page,
        size: this.size,
        keywords: this.keywords
      }).then(res => {
        if (res.status === 1) {
          this.total = res.data.total
          this.tableData = res.data.rows
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      })
    }
  },
  mounted() {
    this.getRoleListData()
  }
}
</script>
